'use client';

import { useEffect } from 'react';
import { useSession, signOut } from 'next-auth/react';

export function SessionErrorHandler() {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (
      status === 'authenticated' &&
      session?.error === 'RefreshAccessTokenError'
    ) {
      console.error('Session has refresh error, forcing logout...');
      signOut({ redirect: true, callbackUrl: '/auth/login' });
    }
  }, [session, status]);

  return null;
}
